import React from 'react';
import PropTypes from 'prop-types';

const IconFolderClose = ({ fill }) => {
  return (
    <svg width="10" height="8" viewBox="0 0 10 8" fill="none">
      <path
        d="M8.95931 7.5H1.04264C0.46806 7.5 0.000976562 7.0325 0.000976562 6.45833V1.04167C0.000976562 0.4675 
        0.46806 0 1.04264 0H3.16181C3.32848 0 3.48556 0.065 3.60389 0.182917L4.19306 0.772083C4.23223 0.811667 
        4.28431 0.833333 4.34014 0.833333H8.95931C9.53389 0.833333 10.001 1.30083 10.001 1.875V6.45833C10.001 
        7.0325 9.53389 7.5 8.95931 7.5Z"
        fill={fill}
      />
    </svg>
  );
};

IconFolderClose.propTypes = {
  fill: PropTypes.string,
};

export default IconFolderClose;
